var map = {
	"./factory3.jpeg": 5800,
	"./shell_core_shooter.jpg": 9255,
	"./shell_core_shooter.png": 9671,
	"./testing_1.jpg": 9772,
	"./testing_2.jpg": 6747,
	"./testing_3.jpg": 5438,
	"./testing_4.jpg": 2773,
	"./testing_5.jpg": 5160,
	"./testing_6.jpg": 6087
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4744;